<app-interview-sidebar>
  <div class="full-width" [ngClass]="isMobile() ? ['vertical'] : ['vertical-large']">
    <div class="page-title">Get Started in 3 Steps</div>

    <div class="horizontal-large top">
      <div class="steps">
        @if (isLoading()) {
          <nz-skeleton [nzActive]="true"></nz-skeleton>
        } @else {
          <nz-steps [nzCurrent]="currentIndex" nzDirection="vertical" nzSize="small">
            <nz-step nzTitle="Add Your Target Position" [nzDescription]="step1">
              <ng-template #step1>
                <div class="vertical-large step-content">
                  @if (goalList().length > 0) {
                    <button
                      class="list-btn"
                      nz-button
                      nzType="text"
                      nzSize="small"
                      (click)="onTargetPositionListClick()"
                    >
                      <span nz-icon style="font-size: 16px" class="material-icons-outlined">check_circle</span>
                      <span>
                        <b>{{ goalList().length }}</b> positions added</span
                      >
                    </button>
                  }

                  <div>
                    AI assistant will understand the job description and requirements to optimize the guidance for you.
                  </div>

                  <button
                    class="fit-content"
                    nz-button
                    [nzType]="currentIndex === 0 ? 'primary' : 'default'"
                    nzSize="default"
                    (click)="onSetTargetPositionClick()"
                  >
                    <span nz-icon style="font-size: 16px" class="material-icons-outlined">add</span>
                    Add Target Position
                  </button>
                </div>
              </ng-template>
            </nz-step>

            <nz-step nzTitle="Upload Your Resume" [nzDescription]="step2">
              <ng-template #step2>
                <div class="vertical-large step-content">
                  @if (resumeList().length > 0) {
                    <button class="list-btn" nz-button nzType="text" nzSize="small" (click)="onResumeListClick()">
                      <span nz-icon style="font-size: 16px" class="material-icons-outlined">check_circle</span>
                      <span
                        ><b>{{ resumeList().length }}</b> resumes uploaded</span
                      >
                    </button>
                  }

                  <div>
                    AI assistant will analyze the key points in your resume to tailor your responses effectively.
                  </div>

                  <button
                    class="fit-content"
                    nz-button
                    [nzType]="currentIndex === 1 ? 'primary' : 'default'"
                    nzSize="default"
                    [disabled]="currentIndex < 1"
                    (click)="onUploadResumeClick()"
                  >
                    <span nz-icon style="font-size: 16px" class="material-icons-outlined">upload</span>
                    Upload
                  </button>
                </div>
              </ng-template>
            </nz-step>

            <nz-step nzTitle="Start Your Interview" [nzDescription]="step3">
              <ng-template #step3>
                <div class="vertical-large step-content">
                  <div>Create and launch your AI interview assistant to start acing your interview.</div>

                  <button
                    class="fit-content"
                    nz-button
                    nzType="primary"
                    nzSize="default"
                    [disabled]="currentIndex < 2"
                    (click)="onLaunchCopilotClick()"
                  >
                    <span nz-icon style="font-size: 16px" class="material-icons-outlined">rocket_launch</span>
                    Start Interview
                  </button>
                </div>
              </ng-template>
            </nz-step>
          </nz-steps>
        }
      </div>

      <div class="video-list vertical-large" [ngClass]="isMobile() ? ['video-list-handset'] : ['video-list-normal']">
        @for (video of videoList; track $index) {
          <div class="video-item vertical">
            <youtube-player [videoId]="video.id" suggestedQuality="highres" [width]="320" [height]="195">
            </youtube-player>
            <div class="video-title">{{ video.title }}</div>
          </div>
        }
      </div>
    </div>
  </div>
</app-interview-sidebar>

<app-new-edit-goal [(isNewEditGoalVisible)]="isNewEditGoalVisible" [isEditGoal]="false"></app-new-edit-goal>

<app-upload-resume [(isNewResumeVisible)]="isNewResumeVisible"></app-upload-resume>

<app-new-interview-copilot [(isNewInterviewVisible)]="isNewInterviewVisible"></app-new-interview-copilot>
